export enum ProductTypes {
  ProductType = 'sangerCrispr',
  ProductName = 'crispr',
  Shrna = 'shrna',
}

export enum ActiveLinkType {
  ProductSearch = 'productSearch',
  ItemSelection = 'itemSelection',
  Specifications = 'specifications',
  ReviewOrder = 'reviewOrder',
  ProductName = 'sangerCrispr',
  Geneknockout = 'geneknockout',
  priceDash = '--',
}

export enum UploadQueriesInstructions {
  UploadTermsCount = 'Enter Up To 100 Gene Symbols, Gene IDs, or Sanger Clone IDs Below (1 per cell)',
  UploadIdentifiers = 'Either NCBI or ENSEMEBL identifiers can be used',
}

export enum FileFormat {
  InvalidTemplate = 'INVALID_TEMPLATE',
  AcceptFormat = '.csv,.xls,.xlsx, text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
}

export enum SpecificationMessages {
  GLYCEROL = 'GLYCEROL',
  DNA = 'DNA',
  VIRUS = 'VIRUS',
  VOLUME = 'VOLUME',
  Aliquoting = 'Aliquoting',
  Two = '2',
  Five = '5',
  Yes = 'Y',
  No = 'N',
  Amount = 'Amount',
  Titer = 'Viral Titer',
  powerof6 = 'powerof6',
  powerof7 = 'powerof7',
  powerof8 = 'powerof8',
  powerof9 = 'powerof9',
  pointTwo = 'pointTwo',
  pointOne = 'pointOne',
  volOne = 'volOne',
  volTwo = 'volTwo',
  volFive = 'volFive',

  ten = '10',
  TwentyFive = '25',
  hundred = '100',
  oneRom = 'one',
  tenRom = 'ten',
  twentyFiveRom = 'twentyFive',
  hundredRom = 'hundred',

  Mul1X200 = 'Mul1X200',
  Mul2X100 = 'Mul2X100',
  Mul4X50 = 'Mul4X50',
  Mul8X25 = 'Mul8X25',
  Mul5X20 = 'Mul5X20',
  Mul2X50 = 'Mul2X50',
  Mul4X25 = 'Mul4X25',
  Mul5X200 = 'Mul5X200',
  Mul10X100 = 'Mul10X100',
  Mul20X50 = 'Mul20X50',
  Mul40X25 = 'Mul40X25',
  Mul25X200 = 'Mul25X200',
  Mul50X100 = 'Mul50X100',
  Mul100X50 = 'Mul100X50',
  Mul200X25 = 'Mul200X25',
  Mul10X200 = 'Mul10X200',
  Mul20X100 = 'Mul20X100',
  Mul40X50 = 'Mul40X50',
  Mul80X25 = 'Mul80X25',
  Mul50X20 = 'Mul50X20',
  Mul100X20 = 'Mul100X20',
  Mul10X20 = 'Mul10X20',

  mul5X20 = '5 x 20',
  mul2X50 = '2 x 50',
  mul4X25 = '4 x 25',
  mul5X200 = '5 x 200',
  mul10X100 = '10 x 100',
  mul20X50 = '20 x 50',
  mul40X25 = '40 x 25',
  mul25X200 = '25 x 200',
  mul50X100 = '50 x 100',
  mul100X50 = '100 x 50',
  mul200X25 = '200 x 25',
  mul10X200 = '10 x 200',
  mul20X100 = '20 x 100',
  mul40X50 = '40 x 50',
  mul80X25 = '80 x 25',
  mul50X20 = '50 x 20',
  mul100X20 = '100 x 20',
  mul10X20 = '10 x 20',
  mul1x200Val = '1 x 200 μl',
  mul2X100Val = '2 x 100 μl',
  mul4X50Val = '4 x 50 μl',
  mul8X25Val = '8 x 25 μl',
  mul5X20Val = '5 x 20 μl',
  mul2X50Val = '2 x 50 μl',
  mul4X25Val = '4 x 25 μl',
  mul5X200Val = '5 x 200 μl',
  mul10X100Val = '10 x 100 μl',
  mul20X50Val = '20 x 50 μl',
  mul40X25Val = '40 x 25 μl',
  mul25X200Val = '25 x 200 μl',
  mul50X100Val = '50 x 100 μl',
  mul100X50Val = '100 x 50 μl',
  mul200X25Val = '200 x 25 μl',
  mul10X200Val = '10 x 200 μl',
  mul20X100Val = '20 x 100 μl',
  mul40X50Val = '40 x 50 μl',
  mul80X25Val = '80 x 25 μl',
  mul50X20Val = '50 x 20 μl',
  mul100X20Val = '100 x 20 μl',
  mul10X20Val = '10 x 20 μl',

  TenPSixVal = '10^6 particles/ml',
  TenPSevenVal = '10^7 particles/ml',
  TenPEightVal = '10^8 particles/ml',
  TenPNineVal = '10^9 particles/ml',

  dotTwoVal = '200 μl',
  dotOneVal = '100 μl',
  oneVolVal = '1 ml',
  twoVolVal = '2 ml',
  fiveVolVal = '5 ml',
  GlycerolVal = 'Sanger Bacterial Glycerol Stock',
  VIRUSVal = 'Sanger Lentivirus',
  DNAVal = 'Sanger Plasmid DNA',
  oneVal = '1 μg',
  tenVal = '10 μg',
  TwentyFiveVal = '25 μg',
  hundredVal = '100 μg',

  All = 'All',
  Selected = 'Selected',

  microLtr = ' μl',
  noSelection = 'noSelection',

  oneAmountVal = '1',
  tenAmountVal = '10',
  TwentyFiveAmountVal = '25',
  hundredAmountVal = '100',

  TenPSix = '10^6',
  TenPSeven = '10^7',
  TenPEight = '10^8',
  TenPNine = '10^9',

  dotTwo = '0.2',
  dotOne = '0.1',
  oneVol = '1',
  twoVol = '2',
  fiveVol = '5',

  mul1x200 = '1 x 200',
  mul2X100 = '2 x 100',
  mul4X50 = '4 x 50',
  mul8X25 = '8 x 25',

  quote = 'QUOTE',
  ZeroPrice = 0,
}

export enum PerPage {
  PerPage10 = '10',
  PerPage20 = '20',
  PerPage30 = '30',
  PerPage50 = '50',
  PerPage100 = '100',
  PerPageALL = 'All',
}

export enum SortBy {
  sangerCloneIdAsc = 'Sanger Clone ID - ASC',
  sangerCloneIdDsc = 'Sanger Clone ID - DESC',
  ensemblGeneSymAsc = 'Ensembl Gene Symbol - ASC',
  ensemblGeneSymDsc = 'Ensembl Gene Symbol - DESC',
  ensemblGeneIdAsc = 'Ensembl Gene ID ASC',
  ensemblGeneIdDsc = 'Ensembl Gene ID DESC',
  ncbiGeneSymAsc = 'NCBI Gene Symbol - ASC',
  ncbiGeneSymDsc = 'NCBI Gene Symbol - DESC',
  ncbiGeneIdAsc = 'NCBI Gene ID ASC',
  ncbiGeneIdDsc = 'NCBI Gene ID DESC',
  speciesAsc = 'Species ASC',
  speciesDsc = 'Species DESC',
  sangerCloneId = 'sangerCloneId',
  ensemblGeneSym = 'ensemblGeneSymbol',
  ensemblGeneId = 'ensemblGeneId',
  ncbiGeneSym = 'ncbiGeneSymbol',
  gRNACategory = 'gRNACategory',
  ncbiGeneId = 'ncbiGeneId',
  species = 'species',
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum SemiConfigProperties {
  Quote = 'QUOTE',
  LoggedInUser = 'LoggedInUser',
  None = 'None',
  Continue = 'continue',
  AddOligo = 'addOligo',
  ErrorUrl = 'https://www.sigmaaldrich.com/webapp/wcs/stores/servlet/UserRegNavigation?storeId=11001',
  Success = 'success',
}

export enum ErrorMessage {
  SessionDataEmpty = 'ERROR_SESSION_DATA_EMPTY',
  AccessTokenExpire = 'ERROR_USER_INVALID_OR_EXPIRED_ACCESS_TOKEN',
}
export enum Url {
  CrisprUrl = '/technical-documents/articles/biology/crispr-clone-control-and-cas9-essentials.html#Cas9',
  SequenceUrl = '/semi-configurators/crispr?activeLink=productSearch',
}

export enum DownloadOrderSummaryProps {
  ProductType = 'crispr',
  FileName = 'OrderSummary_Crispr.xls',
}
